import { render, staticRenderFns } from "./item_detail.vue?vue&type=template&id=73977937&scoped=true&"
import script from "./item_detail.vue?vue&type=script&lang=js&"
export * from "./item_detail.vue?vue&type=script&lang=js&"
import style0 from "./item_detail.vue?vue&type=style&index=0&id=73977937&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73977937",
  null
  
)

export default component.exports